/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

const getBundleContents = () => {
    return JSON.parse(localStorage.getItem('ecomify-bundle-v2') || '[]')
}



const updateProductTypeButtons = () => {
    const bundleContents = getBundleContents()

    const productTypeVariantMap = {}
    bundleContents.forEach(item => {
        if (item.product_type) {
            productTypeVariantMap[item.product_type] = item.variant_id
        }
    })

    let hasService = bundleContents.some(item => item.product_type === 'service');

    let activeService = document.querySelector('.bundle-third-step');

    if (activeService) {
        if (hasService) {
            let btn = document.querySelector('.dummy-button');
            let val = btn.getAttribute('data-text-added-to-bundle');
            btn.textContent = val;
            btn.disabled = true
            btn.style.opacity = '0.5'
            btn.style.cursor = 'not-allowed'
            btn.style.pointerEvents = 'none'
            btn.style.pointerEvents = 'auto'
            activeService.classList.add('active');

            let existingClone = document.querySelector('.appointo-clone');

            if (!existingClone) {
                let appointoBtn = document.querySelector('#appointo-btn-0');
                if (appointoBtn) {
                    let clone = appointoBtn.cloneNode(true);
                    clone.id = '';
                    clone.classList.add('appointo-clone');
                    clone.classList.add('btn');
                    clone.innerHTML = 'Schedule & Proceed';
                   if(!clone.innerHTML || !clone.innerHTML.trim()){
                        clone.innerHTML = 'Schedule & Proceed';   
                    }
                    clone.addEventListener('click', e => {
                        e.preventDefault();
                        appointoBtn.click();
                    });

                    let addToCartBtn = document.querySelector('#bundle-card .bundle-btn-atc');
                    addToCartBtn.parentNode.insertBefore(clone, addToCartBtn);

                    const observer = new MutationObserver((mutations) => {
                        mutations.forEach((mutation) => {
                            if (mutation.type === 'attributes') {
                                if (mutation.attributeName === 'class') {
                                    clone.className = appointoBtn.className + ' appointo-clone';
                                } else if (mutation.attributeName === 'style') {
                                    
                                    //clone.style.cssText = appointoBtn.style.cssText;
                                }
                            } else if (mutation.type === 'childList' || mutation.type === 'characterData') {
                                clone.innerHTML = appointoBtn.innerHTML;
                                 if(!appointoBtn.innerHTML || !appointoBtn.innerHTML.trim() || !appointoBtn.innerHTML.trim() =='undefined' ){
                                  clone.innerHTML = 'Schedule & Proceed';   
                                }
                            }
                        });
                    });

                    observer.observe(appointoBtn, {
                        attributes: true,
                        childList: true,
                        subtree: true,
                        characterData: true
                    });

                    clone._syncObserver = observer;
                }
            }

        } else {

            let btn = document.querySelector('.dummy-button');
            let val = btn.getAttribute('data-text-add-to-bundle');
            btn.textContent = val;
            btn.disabled = false
            btn.style.opacity = '1'
            btn.style.cursor = 'pointer'
            btn.style.pointerEvents = 'auto'
            activeService.classList.remove('active');

            let existingClone = document.querySelector('.appointo-clone');
            if (existingClone) {
                if (existingClone._syncObserver) {
                    existingClone._syncObserver.disconnect();
                }
                existingClone.remove();

            }
        }
    }

    document.querySelectorAll('details.product-type-group').forEach(details => {
        details.classList.remove('product-added')
    })


    const addedProductTypes = new Set()


    document.querySelectorAll('li[product-type]').forEach(li => {
        const productType = li.getAttribute('product-type')
        const form = li.querySelector('form')
        const btn = form?.querySelector('.btn-atc')

        if (!btn || !productType) return


        const detailsElement = li.closest('ul')?.closest('.product-type-items')?.closest('details.product-type-group')
        let thirdstep = false;

        if (productTypeVariantMap.hasOwnProperty(productType)) {

            if (detailsElement && !addedProductTypes.has(productType)) {
                detailsElement.classList.add('product-added')
                addedProductTypes.add(productType)
            }


            const variantInBundle = productTypeVariantMap[productType]


            const variantIdInput = form.querySelector('[name="id"]')
            const currentVariantId = variantIdInput ? Number(variantIdInput.value) : null

            if (currentVariantId === variantInBundle) {
                  let val = btn.getAttribute('data-text-added-to-bundle');
                btn.textContent = val;
                btn.disabled = false
                btn.style.opacity = '1'
                btn.style.cursor = 'not-allowed'
                btn.style.pointerEvents = 'none'

            } else {
              
                btn.disabled = true
                btn.style.opacity = '0.5'
                btn.style.cursor = 'not-allowed'
                btn.style.pointerEvents = 'none'

            }
        } else {

            btn.disabled = false
            btn.style.opacity = '1'
            btn.style.cursor = 'pointer'
            btn.style.pointerEvents = 'auto'
            btn.innerHTML = btn.dataset.textAddToBundle
        }
    })
}


window.addEventListener("load", (event) => {
/*    const checkAppointlyLoaded = setInterval(() => {
    if (window.appointlyMomentLoaded === true) {
        
        clearInterval(checkAppointlyLoaded);
    }
}, 1000);*/
updateProductTypeButtons();

});


const initBundle = () => {
    const tiers = window.ecomify_bundle.tiers.split(',')
    const totalPrice = getBundleContents().reduce((accumulator, currentValue) =>
        (currentValue.variant_price * currentValue.quantity) + accumulator, 0)

    // Get total quantity
    const totalQuantity = getBundleContents().reduce((sum, item) => sum + item.quantity, 0)

    // Get minimum quantity from first tier
    const minQuantity = Number(tiers[0].split(':')[0])

    // Filter out discount tiers (exclude 'min' tier)
    const discountTiers = tiers.filter(tier => tier.split(':')[1] !== 'min')

    document.querySelectorAll('.bundle-progress').forEach(progress => {
        const progressBar = progress.querySelector('.progress-bar')
        const progressText = progress.closest('.bundle-progress-wrapper').querySelector('.progress-text')
        const maxQuantity = Number(tiers[tiers.length - 1].split(':')[0])
        const width = Math.round(totalQuantity / maxQuantity * 100)

        if (totalQuantity < maxQuantity) {
            progressBar.style.width = width + '%'
            progressBar.setAttribute('aria-valuenow', width)
            progressBar.classList.remove(progressBar.dataset.colorCompleted)
            progressBar.classList.add(progressBar.dataset.colorUncompleted)

            // Check if minimum quantity is reached
            if (totalQuantity < minQuantity) {
                // Show minimum requirement message
                const remaining = minQuantity - totalQuantity

                let textUncompleted = progressText.dataset.textUncompleted
                textUncompleted = textUncompleted.replace('[value]', `<b>${remaining} ${remaining === 1 ? 'item' : 'items'}</b>`)
                textUncompleted = textUncompleted.replace('[percentage]', `<b>minimum</b>`)
                progressText.innerHTML = textUncompleted
            } else {
                // Show next discount tier message
                const nextTier = discountTiers.find(elem => Number(elem.split(':')[0]) > totalQuantity)

                if (nextTier) {
                    const tierQuantity = Number(nextTier.split(':')[0])
                    const remaining = tierQuantity - totalQuantity
                    const percentage = nextTier.split(':')[1] + '%'

                    let textUncompleted = progressText.dataset.textUncompleted
                    textUncompleted = textUncompleted.replace('[value]', `<b>${remaining} ${remaining === 1 ? 'item' : 'items'}</b>`)
                    textUncompleted = textUncompleted.replace('[percentage]', `<b>${percentage}</b>`)
                    progressText.innerHTML = textUncompleted
                }
            }

            progressText.classList.remove(progressBar.dataset.colorCompleted.replace('bg-', 'text-'))
        } else {
            progressBar.style.width = '100%'
            progressBar.setAttribute('aria-valuenow', 100)
            progressBar.classList.remove(progressBar.dataset.colorUncompleted)
            progressBar.classList.add(progressBar.dataset.colorCompleted)

            const percentage = tiers[tiers.length - 1].split(':')[1] + '%'

            let textCompleted = progressText.dataset.textCompleted
            textCompleted = textCompleted.replace('[percentage]', `<b>${percentage}</b>`)
            progressText.innerHTML = textCompleted
            progressText.classList.add(progressBar.dataset.colorCompleted.replace('bg-', 'text-'))
        }
    })

    document.querySelectorAll('.bundle-btn-atc').forEach(btn => {
        // Disable button if total price is 0 OR if minimum quantity not met
        btn.disabled = totalPrice === 0 || totalQuantity < minQuantity
    })

    document.querySelectorAll('[data-bundle-price]').forEach(elem => {
        // Find applicable discount tier (excluding 'min' tier)
        const tier = discountTiers.slice().reverse().find(elem => Number(elem.split(':')[0]) <= totalQuantity)

        if (tier) {
            const tierDiscount = Number(tier.split(':')[1])
            const compareAtPrice = Shopify.formatMoney(totalPrice)
            const price = Shopify.formatMoney((1 - (tierDiscount / 100)) * totalPrice)
            elem.innerHTML = `<s class="text-muted fw-normal">${compareAtPrice}</s> ${price}`
        } else {
            elem.innerHTML = Shopify.formatMoney(totalPrice)
        }
    })

    document.querySelectorAll('[data-bundle-discount]').forEach(elem => {
        // Find applicable discount tier (excluding 'min' tier)
        const tier = discountTiers.slice().reverse().find(elem => Number(elem.split(':')[0]) <= totalQuantity)

        let tierDiscount = 0

        if (tier) {
            tierDiscount = Number(tier.split(':')[1])
        }

        const savings = Shopify.formatMoney(tierDiscount / 100 * totalPrice)
        elem.innerHTML = `${savings} (${tierDiscount}%)`
    })

    initBundleContents()

    // Update button states based on product types in bundle
    updateProductTypeButtons()
}
initBundle()
window.addEventListener('updated.ecomify.collection', initBundle)

// 'Add to bundle' form
window.onSubmitBundleForm = async (form, event) => {
    event.preventDefault()

    const btn = form.querySelector('.btn-atc')

    // Temporarily disable the button during animation
    btn.disabled = true
    btn.style.pointerEvents = 'none'

    btn.innerHTML = btn.dataset.textAddedToBundle

    btn.classList.add('animate__animated', 'animate__flash')

    setTimeout(() => {
        //btn.innerHTML = btn.dataset.textAddToBundle
        btn.innerHTML = btn.dataset.textAddedToBundle
        btn.classList.remove('animate__animated', 'animate__flash')
        // Re-enable will be handled by updateProductTypeButtons in initBundle
    }, 1500)

    const productId = Number(form.querySelector('[name="product_id"]').value)
    const productTitle = form.querySelector('[name="product_title"]').value
    const variantId = Number(form.querySelector('[name="id"]').value)
    const variantTitle = form.querySelector('[name="variant_title"]').value
    const variantPrice = Number(form.querySelector('[name="variant_price"]').value)
    const variantImage = form.querySelector('[name="variant_image"]').value

    // Get product type from closest li element
    const productLi = form.closest('li[product-type]')
    const productType = productLi ? productLi.getAttribute('product-type') : null
    const reviews = productLi?.querySelector('.jdgm-widget')?.outerHTML || null
    const producthandle = productLi?.querySelector('.quick-view-btn')?.getAttribute('data-handle') || null
    const bundleContents = getBundleContents()

    if (bundleContents.find(elem => elem.variant_id === variantId)) {
        bundleContents.map(elem => {
            if (elem.variant_id === variantId) {
                elem.quantity += 1
            }
            return elem
        })
    } else {
        bundleContents.push({
            product_id: productId,
            product_handle: producthandle,
            product_title: productTitle,
            variant_id: variantId,
            variant_title: variantTitle,
            variant_price: variantPrice,
            variant_image: variantImage,
            product_type: productType,
            product_reviews: reviews,
            quantity: 1
        })
    }

    console.log(bundleContents)

    localStorage.setItem('ecomify-bundle-v2', JSON.stringify(bundleContents))

    initBundle()
}


window.onReserveSubmitBundleForm = async (form, event) => {
    event.preventDefault()

    const btn = form.querySelector('.dummy-button')

    // Temporarily disable the button during animation
    btn.disabled = true
    btn.style.pointerEvents = 'none'

    btn.innerHTML = btn.dataset.textAddedToBundle

    btn.classList.add('animate__animated', 'animate__flash')

    setTimeout(() => {
        //btn.innerHTML = btn.dataset.textAddToBundle
        btn.innerHTML = btn.dataset.textAddedToBundle
        btn.classList.remove('animate__animated', 'animate__flash')
        // Re-enable will be handled by updateProductTypeButtons in initBundle
    }, 1500)

    const productId = Number(form.querySelector('[name="product_id"]').value)
    const productTitle = form.querySelector('[name="product_title"]').value
    const variantId = Number(form.querySelector('[name="id"]').value)
    const variantTitle = form.querySelector('[name="variant_title"]').value
    const variantPrice = Number(form.querySelector('[name="variant_price"]').value)
    const variantImage = form.querySelector('[name="variant_image"]').value

    // Get product type from closest li element
    const productLi = form.closest('li[product-type]')
    const productType = productLi ? productLi.getAttribute('product-type') : null
    const reviews = productLi?.querySelector('.jdgm-widget')?.outerHTML || null
    const producthandle = productLi?.querySelector('.quick-view-btn')?.getAttribute('data-handle') || null
    const bundleContents = getBundleContents()

    if (bundleContents.find(elem => elem.variant_id === variantId)) {
        bundleContents.map(elem => {
            if (elem.variant_id === variantId) {
                elem.quantity += 1
            }
            return elem
        })
    } else {
        bundleContents.push({
            product_id: productId,
            product_handle: producthandle,
            product_title: productTitle,
            variant_id: variantId,
            variant_title: variantTitle,
            variant_price: variantPrice,
            variant_image: variantImage,
            product_type: productType,
            product_reviews: reviews,
            quantity: 1
        })
    }

    console.log(bundleContents)

    localStorage.setItem('ecomify-bundle-v2', JSON.stringify(bundleContents))

    initBundle()
}


window.quickviewonSubmitBundleForm = async (form, event) => {
    event.preventDefault()

    const variantId = form.querySelector('[name="id"]').value
    const productId = form.querySelector('[name="product_id"]').value

    const quickviewModal = document.getElementById('quickviewModal')

    if (quickviewModal) {
        const modalInstance = bootstrap.Modal.getInstance(quickviewModal) || new bootstrap.Modal(quickviewModal)
        modalInstance.hide()

        setTimeout(() => {
            document.querySelector('.modal-backdrop')?.remove()
            document.body.classList.remove('modal-open')
            document.body.style.removeProperty('overflow')
            document.body.style.removeProperty('padding-right')
        }, 100)
    }

    await new Promise(resolve => setTimeout(resolve, 400))

    const targetForm = document.querySelector(`form[id="product_form_${productId}"]`)

    if (targetForm) {
        const matchingButton = targetForm.querySelector(`button.dropdown-item[data-variant-id="${variantId}"]`)

        if (matchingButton) {
            matchingButton.click()
        } else {
            const mainButton = targetForm.querySelector('button.btn-atc')
            if (mainButton) {
                mainButton.click()
            }
        }
    }
}

window.onClickBundleFormVariantpopup = async (btn, event) => {
    const form = btn.closest('form')

    form.querySelector('[name="id"]').value = btn.dataset.variantId
    form.querySelector('[name="variant_price"]').value = btn.dataset.variantPrice
    form.querySelector('[name="variant_image"]').value = btn.dataset.variantImage
    form.querySelector('[name="variant_title"]').value = btn.dataset.variantTitle

    window.quickviewonSubmitBundleForm(form, event)
}



// Add to bundle form based on variant
window.onClickBundleFormVariant = async (btn, event) => {
    const form = btn.closest('form')

    form.querySelector('[name="id"]').value = btn.dataset.variantId
    form.querySelector('[name="variant_price"]').value = btn.dataset.variantPrice
    form.querySelector('[name="variant_image"]').value = btn.dataset.variantImage
    form.querySelector('[name="variant_title"]').value = btn.dataset.variantTitle

    window.onSubmitBundleForm(form, event)
}

// Add Bundle Contents to Cart
window.addBundleContentsToCart = async (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    const items = getBundleContents().reduce((accumulator, currentValue) => {
        accumulator.push({
            id: currentValue.variant_id,
            quantity: currentValue.quantity
        })
        return accumulator
    }, [])

    console.log(items)

    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            items
        })
    })

    const modal = bootstrap.Modal.getOrCreateInstance('#bundle-contents-modal')
    modal?.hide()

    localStorage.removeItem('ecomify-bundle-v2')
    initBundle()

    if (btn.dataset.redirectToCheckout === 'true') {
        window.location.href = '/checkout'
    } else {
        btn.innerHTML = window.theme.product.addedToCart

        setTimeout(() => {
            // btn.innerHTML = btn.dataset.addedToCart
            btn.innerHTML = 'Add bundle to cart';
        }, 2000)

        window.refreshCartContents(response)
        bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
    }
}

// Sticky bundle card on desktop
const initStickyBundleCard = () => {
    const card = document.querySelector('#bundle-card')

    if (!card) return

    if (window.matchMedia('(min-width: 992px)').matches) {
        const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0
        const announcementBarHeight = document.querySelector('[id*="__announcement-bar"].sticky-top')?.clientHeight || 0

        card.style.position = 'sticky'
        card.style.zIndex = '1'

        window.addEventListener('scroll', window.throttle(() => {
            if (document.querySelector('#collection-utilities').classList.contains('sticky-top')) {
                card.style.top = `${navbarHeight + announcementBarHeight + 82}px`
            } else {
                card.style.top = `${navbarHeight + announcementBarHeight + 20}px`
            }
        }, 200))
    }
}
initStickyBundleCard()
window.addEventListener('updated.ecomify.collection', initStickyBundleCard)

// Bundle Contents Modal
function initBundleContents() {
    const modal = document.querySelector('#bundle-contents-modal')

    if (getBundleContents().length === 0) {
        modal.querySelector('.bundle-contents-empty').removeAttribute('hidden')
        modal.querySelector('.product-list').setAttribute('hidden', 'hidden')
        return
    }

    const list = modal.querySelector('.product-list')

    let listHtml = ''



    getBundleContents().forEach(elem => {
        listHtml += `
            <li class="product-item py-4">
                <div class="row align-items-center mx-n3">
                    <div class="col-4 px-3">
                        <img 
                            class="product-item-img img-fluid rounded ${list.dataset.imgThumbnail}" 
                            src="${Shopify.resizeImage(elem.variant_image || 'no-image.gif', `${list.dataset.imgWidth}x${list.dataset.imgHeight}`, 'center')}"
                            alt="" 
                            width="${list.dataset.imgWidth}"
                            height="${list.dataset.imgHeight}"
                            loading="lazy">
                    </div>
                    <div class="col-8 px-3">
                        <h3 class="product-item-title h6 mb-2">
                            ${elem.product_title}
                        </h3>
                        <p class="small text-muted mt-n1 mb-0" ${elem.variant_title.includes('Default Title') ? 'hidden' : ''}>
                            ${elem.variant_title}
                        </p>
                        ${elem.product_reviews ? `<p class="small text-muted mt-n1 mb-0 reviews">${elem.product_reviews}</p>` : ''}

                        <p class="product-item-price-final mb-2">
                            ${Shopify.formatMoney(elem.variant_price)}
                        </p>
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="quantity-wrapper">
                                <button 
                                    class="btn"
                                    type="button"
                                    data-mode="minus"
                                    onclick="onClickQtyPlusMinus(this)" 
                                    aria-label="${list.dataset.textDecreaseQty}">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <line x1="5" y1="12" x2="19" y2="12"></line>
                                    </svg>
                                </button>
                                <input 
                                    class="form-control" 
                                    type="text"
                                    value="${elem.quantity}"
                                    data-min-qty="0"
                                    data-variant-id="${elem.variant_id}"
                                    aria-label="${list.dataset.textDecreaseQty}"
                                    onchange="onChangeBundleItemQty(this)">
                                <button 
                                    class="btn btn-plus"
                                    type="button"
                                    data-mode="plus"
                                    onclick="onClickQtyPlusMinus(this)"
                                    aria-label="${list.dataset.textIncreaseQty}">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line>
                                    </svg>
                                </button>
                            </div>
                            <button 
                                class="btn-remove btn btn-sm ms-2"
                                onclick="onRemoveBundleItem(this)"
                                data-variant-id="${elem.variant_id}"
                                aria-label="${list.dataset.textRemove}"
                                type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" class="" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </li>
        `
    })

    list.innerHTML = listHtml
    list.removeAttribute('hidden')
    modal.querySelector('.bundle-contents-empty').setAttribute('hidden', 'hidden')
}

// Quantity change (bundle contents)
window.onChangeBundleItemQty = (input, event) => {
    let bundleContents = getBundleContents()

    if (Number(input.value) === 0) {
        bundleContents = bundleContents.filter((elem) =>
            elem.variant_id !== Number(input.dataset.variantId))
    } else {
        bundleContents.map(elem => {
            if (elem.variant_id === Number(input.dataset.variantId)) {
                elem.quantity = Number(input.value)
            }
            return elem
        })
    }

    localStorage.setItem('ecomify-bundle-v2', JSON.stringify(bundleContents))

    initBundle()
}

// Remove bundle items (bundle contents)
window.onRemoveBundleItem = (btn, event) => {
    let bundleContents = getBundleContents()

    bundleContents = bundleContents.filter((elem) =>
        elem.variant_id !== Number(btn.dataset.variantId))

    localStorage.setItem('ecomify-bundle-v2', JSON.stringify(bundleContents))

    initBundle()
}

/*
    Sticky Bundle Card on mobile
*/
const initStickyBundleCardMobile = async () => {
    const wrapper = document.querySelector('#bundle-card-sticky-mobile')

    if (!wrapper) return

    await new Promise(resolve => setTimeout(resolve, 1000))

    const threshold = document.querySelector('#bundle-card').getBoundingClientRect().bottom + window.scrollY

    window.addEventListener('scroll', () => {
        if (window.scrollY > threshold) {
            wrapper.classList.add('show')
            document.body.style.paddingBottom = wrapper.clientHeight + 'px'
        } else {
            wrapper.classList.remove('show')
            document.body.style.paddingBottom = 0
        }
    })
}
initStickyBundleCardMobile()


window.addBundleToWishlist = async (btn, event) => {
    event.preventDefault()

    const bundleContents = getBundleContents()

    if (bundleContents.length === 0) {
        return
    }

    btn.disabled = true
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>`;

    let wishlist = JSON.parse(localStorage.getItem('ecomify_wishlist_v1')) || []

    for (const bundleItem of bundleContents) {
        const isAlreadyInWishlist = wishlist.some((elem) => elem.handle === bundleItem.product_handle)

        if (isAlreadyInWishlist) continue

        // Map bundleContents data directly to wishlist format
        wishlist.push({
            id: bundleItem.product_id,
            handle: bundleItem.product_handle,
            url: `/products/${bundleItem.product_handle}`,
            title: bundleItem.product_title,
            compare_at_price: null,
            price: bundleItem.variant_price,
            price_varies: false,
            featured_image: bundleItem.variant_image,
            vendor: bundleItem.product_type || '',
            inventory: null,
            time: Date.now(),
            variants: [{
                id: bundleItem.variant_id,
                title: bundleItem.variant_title,
                compare_at_price: null,
                price: bundleItem.variant_price,
                featured_image: {
                    src: bundleItem.variant_image
                }
            }]
        })
    }

    localStorage.setItem('ecomify_wishlist_v1', JSON.stringify(wishlist))
    
    btn.disabled = false
    btn.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
    </svg>
    Save kit
`;
    initWishlist()
}

/*window.addBundleToWishlist = async (btn, event) => {
    event.preventDefault()

    const bundleContents = getBundleContents()

    if (bundleContents.length === 0) {
        return
    }
    btn.disabled = true
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>`;
    let wishlist = JSON.parse(localStorage.getItem('ecomify_wishlist_v1')) || []

    for (const bundleItem of bundleContents) {
        console.debug(bundleContents)
        const isAlreadyInWishlist = wishlist.some((elem) => elem.handle === bundleItem.product_handle)

        if (isAlreadyInWishlist) continue

        const response = await fetch(`/products/${bundleItem.product_handle}.js`)
        const product = await response.json()

        const variants = product.variants.map(variant => ({
            id: variant.id,
            title: variant.title,
            compare_at_price: variant.compare_at_price,
            price: variant.price,
            featured_image: {
                src: variant.featured_image?.src || null
            }
        }))

        const productForm = document.querySelector(`form[id="product_form_${bundleItem.product_id}"]`)
        const stockElement = productForm?.closest('.product-item')?.querySelector('.product-stock')
        const inventoryHTML = stockElement?.outerHTML || null

        wishlist.push({
            id: product.id,
            handle: product.handle,
            url: product.url,
            title: product.title,
            compare_at_price: product.compare_at_price,
            price: product.price,
            price_varies: product.price_varies,
            featured_image: product.featured_image,
            vendor: product.vendor,
            inventory: inventoryHTML,
            time: Date.now(),
            variants
        })
    }

    localStorage.setItem('ecomify_wishlist_v1', JSON.stringify(wishlist))
    btn.disabled = false
    btn.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
    </svg>
    Save kit
`;
    initWishlist()
}*/


(function() {
    const originalShowAppointoModal = window.showAppointoModal;

    Object.defineProperty(window, 'showAppointoModal', {
        set: function(value) {
            this._showAppointoModal = async function(e) {
                e.goto_flow = 'embed';

                return value.call(this, e);
            };
        },
        get: function() {
            return this._showAppointoModal;
        },
        configurable: true
    });


})();

(function() {
    const originalFetch = window.fetch;
    let shouldIntercept = false;

    document.addEventListener('click', function(e) {
        if (e.target.id === 'appointo-btn-0' || e.target.closest('#appointo-btn-0')) {
            shouldIntercept = true;
        }
    }, true);

    window.fetch = async function(url, options) {
        if (shouldIntercept && url && url.includes('/cart/add.js')) {
            shouldIntercept = false;

            console.log('🚫 INTERCEPTED - Blocking original request');

            if (options?.body) {
                try {
                    const payload = JSON.parse(options.body);

                    if (payload.items && payload.items.length > 0) {
                        let closeBtn = document.querySelector('.appointo-close');
                        if (closeBtn) {
                            closeBtn.click();
                        }
                        document.body.classList.remove('appointo-fixed');
                    }



                    const bundleItems = getBundleContents().reduce((accumulator, currentValue) => {
                        accumulator.push({
                            id: currentValue.variant_id,
                            quantity: currentValue.quantity
                        });
                        return accumulator;
                    }, []);


                    const payloadItemIds = payload.items && payload.items.length > 0 ?
                        payload.items.map(item => String(item.id)) :
                        [];


                    const filteredBundleItems = bundleItems.filter(bundleItem => {
                        return !payloadItemIds.includes(String(bundleItem.id));
                    });

                    let finalItems = [...filteredBundleItems];

                    if (payload.items && payload.items.length > 0) {
                        finalItems.push(...payload.items);
                    }


                    const response = await originalFetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            items: finalItems
                        })
                    });


                    // CHECK IF RESPONSE IS OK
                    if (!response.ok) {
                        console.error('❌ Cart add failed:', response.status, response.statusText);
                        const errorData = await response.json().catch(() => ({}));
                        console.error('Error details:', errorData);
                        return response;
                    }

                    const btn = document.querySelector('.bundle-btn-atc');

                    if (btn) {
                        const modal = bootstrap.Modal.getOrCreateInstance('#bundle-contents-modal');
                        modal?.hide();

                        localStorage.removeItem('ecomify-bundle-v2');
                        initBundle();

                        if (btn.dataset.redirectToCheckout === 'true') {
                            window.location.href = '/checkout';
                        } else {
                            btn.innerHTML = window.theme.product.addedToCart;

                            setTimeout(() => {
                                btn.innerHTML = 'Add bundle to cart';
                            }, 2000);

                            window.refreshCartContents(response);
                            bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show();
                        }
                    } else {
                        console.warn('⚠️ Bundle button not found: [data-bundle-add-to-cart]');
                    }

                    return response;

                } catch (e) {
                    console.error('📦 PAYLOAD (Raw):', options.body);
                    console.error('⚠️ Error:', e);
                    return Promise.reject(e);
                }
            }

            return Promise.resolve(new Response(JSON.stringify({
                error: 'No payload'
            }), {
                status: 400,
                headers: {
                    'Content-Type': 'application/json'
                }
            }));
        }


        return originalFetch.apply(this, arguments);
    };
})();

document.querySelector('#emailMyKit').addEventListener('click', function(event) {
    event.preventDefault()
    
    const bundleContents = getBundleContents()
    const textarea = document.getElementById('bundletextarea')
    console.debug(bundleContents)
    if (!textarea) {
        console.error('Textarea with id "bundletextarea" not found')
        return
    }
   
    let bundleText = ''
    
    bundleContents.forEach((item) => {
        bundleText += `${item.product_title} - Quantity: ${item.quantity}\n`
    })
    
    textarea.value = bundleText.trim()
})